import type { FieldValues, Resolver } from 'react-hook-form'
import type { z } from 'zod'

import { zodResolver as baseZodResolver } from '@hookform/resolvers/zod'

/**
 * Wrapper around @hookform/resolvers' `zodResolver`.
 *
 * Since v5, `@hookform/resolvers` types the resolved form values using the
 * schema's INPUT type (pre-transform) and distinguishes input vs. output
 * generics. Our forms were written against the looser contract the resolver
 * provided before the zod v3 -> v4 upgrade, where the resolved field-values type
 * is inferred from the form itself (`useForm` defaultValues/explicit generic).
 *
 * This wrapper restores that contract so existing forms keep type-checking
 * without per-form generic changes. The cast bridges the library's stricter
 * generics; it is safe because react-hook-form receives the parsed values from
 * the resolver at runtime exactly as before.
 */
export function zodResolver<TFieldValues extends FieldValues = FieldValues>(schema: z.ZodType): Resolver<TFieldValues> {
  const resolve = baseZodResolver as unknown as (s: z.ZodType) => Resolver<TFieldValues>
  return resolve(schema)
}
